import { render, staticRenderFns } from "./DetailList.vue?vue&type=template&id=1284f70c&scoped=true&"
import script from "./DetailList.vue?vue&type=script&lang=ts&"
export * from "./DetailList.vue?vue&type=script&lang=ts&"
import style0 from "./DetailList.vue?vue&type=style&index=0&id=1284f70c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1284f70c",
  null
  
)

export default component.exports